import type { Namespace, TFunction } from 'i18next';
import type { LegacyTier } from '@nexa/auth';

// Display copy for roles beyond their name (the name is `roleLabel` in `lib/access/labels`).

/** A role's description: system roles translated, custom roles as the airline wrote them. */
export function roleDescription<N extends Namespace>(
  t: TFunction<N>,
  role: { key: string; system: boolean; description?: string },
): string {
  if (role.system) {
    return t(`admin:roleDescriptions.${role.key}`, { defaultValue: role.description ?? '' });
  }
  return role.description ?? '';
}

/** "Nivel base (compatibilidad)" value, e.g. "Supervisor de operaciones". */
export function tierLabel<N extends Namespace>(t: TFunction<N>, tier: LegacyTier): string {
  return t(`admin:baseTiers.${tier}.label`);
}

/** A date in the operator's language ("12 may 2026"), or `null` for never / unreadable. */
export function formatDate(iso: string | null | undefined, lng: string): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  try {
    return new Intl.DateTimeFormat(lng, { dateStyle: 'medium' }).format(d);
  } catch {
    return d.toISOString().slice(0, 10);
  }
}

const DIACRITICS = /[\u0300-\u036f]/g;

/** Case- and accent-insensitive search key ("São Paulo" → "sao paulo"). */
export function foldText(s: string): string {
  return s.normalize('NFD').replace(DIACRITICS, '').toLowerCase();
}
